import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, FormControlLabel, Stack } from '@emburse/embark-core';
import SafeHtmlTypography from '../../../components/SafeHtmlTypography';
function AgreementFooter({ onCheckboxToggled }) {
    const checkboxMessage = 'I understand and agree to the CSG Forte Merchant Services Agreement';
    return (_jsx(Stack, { alignItems: "flex-start", sx: { width: '98%' }, children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { onChange: (event) => onCheckboxToggled?.(event.target.checked) }), label: _jsx(SafeHtmlTypography, { color: "textSecondary", children: checkboxMessage }), sx: { paddingLeft: 1 } }) }));
}
AgreementFooter.defaultProps = {
    onCheckboxToggled: () => { }
};
export default AgreementFooter;
